import * as React from 'react'
import * as styles from '../../../../common/CommonStyles'
import { subMonths } from 'date-fns'
import EnergyAnalysisPercentageUpload from '../../energy/energyAnalysisPercentageUpload'

const mo6 = subMonths(new Date(), 6)

export const EnergyAnalysisUploadsDashboard = ({ data }) => {
    return (
        <div className={styles.SmallGraphBox}>
            <h1 className={styles.DashHeaderClass}>Energy - Upload Percentage</h1>
            <EnergyAnalysisPercentageUpload type="dash" period={mo6} data={data} view="total" />
        </div>
    )
}
